// removed by extract-text-webpack-plugin
module.exports = {"base":"Clan_base--34T2l","emblem":"Clan_emblem--NoGNt","tagName":"Clan_tagName--1nrz2","clanName":"Clan_clanName--245Iu"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Clan/Clan.scss
// module id = 2255
// module chunks = 11